/**
 * Kifoni — Estimación de entrega en la ficha de producto.
 *
 * Calcula la fecha de entrega en días LABORABLES sobre la hora real de
 * Europe/Madrid (no la del navegador del visitante, que puede estar en
 * cualquier huso), excluyendo sábados, domingos y festivos nacionales.
 *
 * Bilingüe: el calendario (nombres de día y de mes, festivos) se elige por el
 * idioma del documento, y las frases llegan traducidas desde Liquid en los
 * data-* del elemento. En francés el plazo es otro (14-20 días laborables) y
 * los festivos también, así que ambas cosas son por idioma. Si el idioma no
 * está soportado se cae a español, que es el idioma principal de la tienda.
 *
 * Idempotente: si el script se carga dos veces no duplica listeners.
 */
(function () {
  'use strict';
  if (window.__kfDeliveryEtaInit) return;
  window.__kfDeliveryEtaInit = true;

  // Festivos NACIONALES por país de entrega. Los autonómicos, locales y los de
  // Alsacia-Mosela no se incluyen: no se puede asumir la provincia ni el
  // departamento del visitante. Revisar y ampliar cada año (ver README).
  var CAL = {
    es: {
      holidays: [
        // 2026
        '2026-01-01', '2026-01-06', '2026-04-03', '2026-05-01', '2026-08-15',
        '2026-10-12', '2026-11-01', '2026-12-06', '2026-12-08', '2026-12-25',
        // 2027
        '2027-01-01', '2027-01-06', '2027-03-26', '2027-05-01', '2027-08-15',
        '2027-10-12', '2027-11-01', '2027-12-06', '2027-12-08', '2027-12-25'
      ],
      days: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      months: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
               'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
      // «lunes 3 de septiembre»
      monthJoiner: ' de '
    },
    fr: {
      holidays: [
        // 2026 — Pâques le 5 avril
        '2026-01-01', '2026-04-06', '2026-05-01', '2026-05-08', '2026-05-14',
        '2026-05-25', '2026-07-14', '2026-08-15', '2026-11-01', '2026-11-11',
        '2026-12-25',
        // 2027 — Pâques le 28 mars
        '2027-01-01', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-08',
        '2027-05-17', '2027-07-14', '2027-08-15', '2027-11-01', '2027-11-11',
        '2027-12-25'
      ],
      days: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
      months: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet',
               'août', 'septembre', 'octobre', 'novembre', 'décembre'],
      // «lundi 3 septembre»
      monthJoiner: ' '
    }
  };

  function calendarFor(el) {
    var lang = (el.dataset.locale || document.documentElement.lang || 'es')
      .slice(0, 2)
      .toLowerCase();
    return CAL[lang] || CAL.es;
  }

  /** Fecha y hora actuales en Europe/Madrid, como objeto plano. */
  function nowInMadrid() {
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Madrid',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', hour12: false
      }).formatToParts(new Date());
    } catch (e) {
      // Navegador sin soporte de zonas horarias: usamos la hora local.
      var d = new Date();
      return { y: d.getFullYear(), m: d.getMonth() + 1, d: d.getDate(), h: d.getHours() };
    }
    var get = function (t) {
      var p = parts.find(function (x) { return x.type === t; });
      return p ? parseInt(p.value, 10) : 0;
    };
    return { y: get('year'), m: get('month'), d: get('day'), h: get('hour') };
  }

  function iso(date) {
    var m = String(date.getUTCMonth() + 1).padStart(2, '0');
    var d = String(date.getUTCDate()).padStart(2, '0');
    return date.getUTCFullYear() + '-' + m + '-' + d;
  }

  function isBusinessDay(date, cal) {
    var wd = date.getUTCDay();
    if (wd === 0 || wd === 6) return false;
    return cal.holidays.indexOf(iso(date)) === -1;
  }

  /** Suma n días laborables a partir del día siguiente al de referencia. */
  function addBusinessDays(from, n, cal) {
    var d = new Date(from.getTime());
    var added = 0;
    var guard = 0;
    while (added < n && guard < 400) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isBusinessDay(d, cal)) added++;
      guard++;
    }
    return d;
  }

  function formatDay(date, withMonth, cal) {
    var s = cal.days[date.getUTCDay()] + ' ' + date.getUTCDate();
    if (withMonth) s += cal.monthJoiner + cal.months[date.getUTCMonth()];
    return s;
  }

  function buildText(el) {
    var cal = calendarFor(el);
    var min = parseInt(el.dataset.minDays, 10) || 3;
    var max = parseInt(el.dataset.maxDays, 10) || 5;
    var cutoff = parseInt(el.dataset.cutoffHour, 10);
    if (isNaN(cutoff)) cutoff = 14;

    var now = nowInMadrid();
    // Trabajamos en UTC puro para que sumar días no se vea afectado por el
    // horario de verano; la fecha de partida ya viene calculada en Madrid.
    var base = new Date(Date.UTC(now.y, now.m - 1, now.d));

    // Pasada la hora de corte, o en fin de semana/festivo, el pedido se
    // prepara el siguiente día laborable: el contador arranca desde ahí.
    var ordersToday = now.h < cutoff && isBusinessDay(base, cal);
    if (!ordersToday) base = addBusinessDays(base, 1, cal);

    var lead = ordersToday ? el.dataset.leadToday : el.dataset.leadNow;

    // RESERVA: el plazo de envío arranca el día de llegada del stock (fecha
    // exacta del proveedor, AAAA-MM-DD), no hoy. Si esa fecha ya pasó se
    // cuenta desde hoy, como un pedido normal.
    var rsv = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.dataset.reserva || '');
    if (rsv) {
      var arrival = new Date(Date.UTC(+rsv[1], +rsv[2] - 1, +rsv[3]));
      if (arrival > base) base = arrival;
      lead = el.dataset.leadReserve;
    }

    var from = addBusinessDays(base, min, cal);
    var to = addBusinessDays(base, max, cal);

    if (!lead) return '';

    if (el.dataset.mode === 'latest') {
      return lead + ' ' + (el.dataset.tplLatest || '')
        .replace('{to}', formatDay(to, true, cal));
    }
    var sameMonth = from.getUTCMonth() === to.getUTCMonth();
    return lead + ' ' + (el.dataset.tplRange || '')
      .replace('{from}', formatDay(from, !sameMonth, cal))
      .replace('{to}', formatDay(to, true, cal));
  }

  function render(el) {
    var target = el.querySelector('[data-kf-delivery-text]');
    if (!target) return;
    try {
      var text = buildText(el);
      // Sin frase traducida no se dice nada: mejor callar que enseñar una
      // plantilla a medio rellenar.
      if (!text) { el.hidden = true; return; }
      target.textContent = text;
    } catch (e) {
      // Ante cualquier fallo se oculta: mejor no decir nada que decir una
      // fecha equivocada.
      el.hidden = true;
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-kf-delivery-eta]').forEach(render);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  init();

  // La fecha solo tiene sentido si la variante seleccionada está disponible.
  document.addEventListener('kf:variant-change', function (ev) {
    var variant = ev.detail && ev.detail.variant;
    var root = ev.target && ev.target.querySelectorAll
      ? ev.target
      : document;
    root.querySelectorAll('[data-kf-delivery-eta]').forEach(function (el) {
      var ok = !!(variant && variant.available);
      el.dataset.reserva = (ok && variant.reserva) || '';
      el.hidden = !ok;
      if (ok) render(el);
    });
  });
})();
